import template from './secureFileUploaderStepIndicator.html';
import controller from './secureFileUploaderStepIndicator.controller';

let secureFileUploaderStepIndicatorComponent = {
  restrict: 'E',
  bindings: {
    stepNumber: '=',
    stepName: '@',
    stepProgress: '=',
    stepError: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default secureFileUploaderStepIndicatorComponent;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderStepIndicator/secureFileUploaderStepIndicator.component.js